import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

import AdminLayout from "../../components/layout/AdminLayout/AdminLayout";
import faqService from "../../services/faq/faqService";

export default function FaqForm() {

    const navigate = useNavigate();

    const { id } = useParams();

    const isEdit = !!id;

    const [loading, setLoading] = useState(false);


    const [form, setForm] = useState({

        question: "",

        answer: "",

        displayOrder: 0,

        isActive: true

    });


    useEffect(() => {

        if (isEdit) {

            loadFaq();

        }

    }, [isEdit]);


    const loadFaq = async () => {

        try {

            setLoading(true);

            const response = await faqService.getById(id);

            if (response.success) {

                const data = response.data;

                setForm({

                    question: data.question || "",

                    answer: data.answer || "",

                    displayOrder: data.displayOrder || 0,

                    isActive: data.isActive

                });

            }

        }
        catch (error) {

            console.log(error);

            toast.error("Failed to load FAQ.");

        }
        finally {

            setLoading(false);

        }

    };


    const handleChange = (e) => {

        const {
            name,
            value,
            type,
            checked
        } = e.target;

        setForm({

            ...form,

            [name] :
                type === "checkbox"
                    ? checked
                    : value

        });

    };


    const handleSubmit = async (e) => {

        e.preventDefault();


        if (!form.question.trim()) {

            toast.error("Question is required.");

            return;

        }


        if (!form.answer.trim()) {

            toast.error("Answer is required.");

            return;

        }


        try {

            setLoading(true);

            let response;


            if (isEdit) {

                response = await faqService.update(
                    id,
                    form
                );

            }
            else {

                response = await faqService.create(
                    form
                );

            }


            if (response.success) {

                toast.success(response.message);

                navigate("/faqs");

            }
            else {

                toast.error(response.message);

            }

        }
        catch (error) {

            console.log(error);

            toast.error("Something went wrong.");

        }
        finally {

            setLoading(false);

        }

    };


    return (

        <AdminLayout>

            <div className="page-header">

                <h2>

                    {
                        isEdit
                            ? "Edit FAQ"
                            : "Add FAQ"
                    }

                </h2>

            </div>


            <div className="card">

                <form onSubmit={handleSubmit}>

                    <div className="card-body">

                        <div className="row g-3">


                            {/* Question */}

                            <div className="col-12">

                                <label className="form-label">

                                    Question

                                    <span className="text-danger">
                                        *
                                    </span>

                                </label>

                                <input
                                    type="text"
                                    className="form-control"
                                    name="question"
                                    value={form.question}
                                    onChange={handleChange}
                                    placeholder="Enter question"
                                />

                            </div>


                            {/* Answer */}

                            <div className="col-12">

                                <label className="form-label">

                                    Answer

                                    <span className="text-danger">
                                        *
                                    </span>

                                </label>

                                <textarea
                                    rows="6"
                                    className="form-control"
                                    name="answer"
                                    value={form.answer}
                                    onChange={handleChange}
                                    placeholder="Enter answer"
                                />

                            </div>


                            {/* Display Order */}

                            <div className="col-lg-3">

                                <label className="form-label">

                                    Display Order

                                </label>

                                <input
                                    type="number"
                                    className="form-control"
                                    name="displayOrder"
                                    value={form.displayOrder}
                                    onChange={handleChange}
                                />

                            </div>


                            {/* Active */}

                            <div className="col-lg-3 d-flex align-items-end">

                                <div className="form-check mb-2">

                                    <input
                                        type="checkbox"
                                        className="form-check-input"
                                        id="isActive"
                                        name="isActive"
                                        checked={form.isActive}
                                        onChange={handleChange}
                                    />

                                    <label
                                        className="form-check-label"
                                        htmlFor="isActive"
                                    >
                                        Active
                                    </label>

                                </div>

                            </div>

                        </div>


                        <hr />


                        <div className="d-flex gap-2">

                            <button
                                type="button"
                                className="btn btn-secondary"
                                onClick={() =>
                                    navigate("/faqs")
                                }
                            >
                                Cancel
                            </button>


                            <button
                                type="submit"
                                className="btn btn-primary"
                                disabled={loading}
                            >

                                {
                                    loading
                                        ? "Saving..."
                                        : isEdit
                                            ? "Update"
                                            : "Save"
                                }

                            </button>

                        </div>

                    </div>

                </form>

            </div>

        </AdminLayout>

    );

}